import { render, staticRenderFns } from "./resultatCategorie.vue?vue&type=template&id=38d4b77d&scoped=true&"
import script from "./resultatCategorie.vue?vue&type=script&lang=js&"
export * from "./resultatCategorie.vue?vue&type=script&lang=js&"
import style0 from "./resultatCategorie.vue?vue&type=style&index=0&id=38d4b77d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d4b77d",
  null
  
)

export default component.exports